"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartAdornmentIcon = exports.StyledGrid = void 0;
const styles_1 = require("@mui/material/styles");
const Icon_1 = __importDefault(require("../icon/Icon"));
const grid_1 = __importDefault(require("../grid"));
exports.StyledGrid = (0, styles_1.styled)(grid_1.default)({
    "& mark": {
        backgroundColor: "transparent",
        fontWeight: "bold"
    }
});
exports.StartAdornmentIcon = (0, styles_1.styled)(Icon_1.default)(({ theme }) => ({
    color: theme.colours.slate,
    width: "18px",
    height: "18px",
    margin: "0 7px"
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2F1dG9jb21wbGV0ZS9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLHdEQUFnQztBQUNoQyxtREFBMkI7QUFFZCxRQUFBLFVBQVUsR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFJLENBQUMsQ0FBQztJQUNyQyxRQUFRLEVBQUU7UUFDUixlQUFlLEVBQUUsYUFBYTtRQUM5QixVQUFVLEVBQUUsTUFBTTtLQUNuQjtDQUNGLENBQUMsQ0FBQztBQUVVLFFBQUEsa0JBQWtCLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzdELEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDMUIsS0FBSyxFQUFFLE1BQU07SUFDYixNQUFNLEVBQUUsTUFBTTtJQUNkLE1BQU0sRUFBRSxPQUFPO0NBQ2hCLENBQUMsQ0FBQyxDQUFDIn0=